import { app } from '../App';
import DebugUI from '../../scenes/DebugUI';

export interface DebugControls {
  toggleDebugControls: Phaser.Input.Keyboard.Key;
  toggleDebugOverlay: Phaser.Input.Keyboard.Key;
  // toggle debug menu.
  toggleAudio: Phaser.Input.Keyboard.Key;
  toggleMusic: Phaser.Input.Keyboard.Key;
  toggleSFX: Phaser.Input.Keyboard.Key;
  playAudio: Phaser.Input.Keyboard.Key;
  stopAudio: Phaser.Input.Keyboard.Key;
  playMusic: Phaser.Input.Keyboard.Key;
  stopMusic: Phaser.Input.Keyboard.Key;
  resumeScene: Phaser.Input.Keyboard.Key;
  pauseScene: Phaser.Input.Keyboard.Key;
}

export class DebugInput {
  protected scene: Phaser.Scene;
  protected debugControls: DebugControls;

  protected allowDebugControls: boolean;

  protected soundId = 'SndItemClick';
  protected musicId = 'SndMusicLoop';
  protected audioRefs: string[];

  constructor(scene: Phaser.Scene) {
    this.scene = scene;

    this.debugControls = this.scene.input.keyboard.addKeys({
      toggleDebugControls: Phaser.Input.Keyboard.KeyCodes.BACK_SLASH,
      toggleDebugOverlay: Phaser.Input.Keyboard.KeyCodes.Z,
      // toggle debug menu.
      toggleAudio: Phaser.Input.Keyboard.KeyCodes.V,
      toggleMusic: Phaser.Input.Keyboard.KeyCodes.B,
      toggleSFX: Phaser.Input.Keyboard.KeyCodes.N,
      playAudio: Phaser.Input.Keyboard.KeyCodes.O,
      stopAudio: Phaser.Input.Keyboard.KeyCodes.P,
      playMusic: Phaser.Input.Keyboard.KeyCodes.M,
      stopMusic: Phaser.Input.Keyboard.KeyCodes.COMMA,
      resumeScene: Phaser.Input.Keyboard.KeyCodes.ONE,
      pauseScene: Phaser.Input.Keyboard.KeyCodes.TWO,
    }) as DebugControls;

    this.allowDebugControls = false;

    this.audioRefs = [];

    this.scene.events.on(Phaser.Scenes.Events.UPDATE, this.update, this);
    this.scene.events.on(Phaser.GameObjects.Events.DESTROY, this.destroy, this);
  }

  protected update(time: number, delta: number) {
    if (Phaser.Input.Keyboard.JustUp(this.debugControls.toggleDebugControls)) {
      this.allowDebugControls = !this.allowDebugControls;
      app.audioHandler.playSound(this.scene, this.soundId, 'sfx');
    }

    if (!this.allowDebugControls) return;

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.toggleDebugOverlay)) {
      this.scene.events.emit(DebugUI.events.ToggleDebugOverlay);
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.toggleAudio)) {
      // Use music as the benchmark and make both match.
      app.audioHandler.setChannelMute('music', !app.audioHandler.getChannelMute('music'));
      app.audioHandler.setChannelMute('sfx', !app.audioHandler.getChannelMute('music'));
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.toggleMusic)) {
      app.audioHandler.setChannelMute('music', !app.audioHandler.getChannelMute('music'));
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.toggleSFX)) {
      app.audioHandler.setChannelMute('sfx', !app.audioHandler.getChannelMute('sfx'));
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.playAudio)) {
      let [ref, success] = app.audioHandler.playSound(this.scene, this.soundId, 'sfx', {
        loop: true
      });

      if (success) this.audioRefs.push(ref);

      console.log(app.audioHandler);
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.stopAudio) && this.audioRefs.length > 0) {
      app.audioHandler.stopAndRemoveSound(this.audioRefs.pop() ?? '', 'sfx');
      console.log(app.audioHandler);
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.playMusic)) {
      app.audioHandler.playSound(this.scene, this.musicId, 'music', {
        volume: 0.1
      });
      console.log(app.audioHandler);
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.stopMusic)) {
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.resumeScene)) {
      let game = this.scene.scene.get("Game");
      game.scene.resume();
    }

    if (Phaser.Input.Keyboard.JustUp(this.debugControls.pauseScene)) {
      let game = this.scene.scene.get("Game");
      game.scene.pause();
    }
  }

  protected destroy() {
    this.scene.events.off(Phaser.Scenes.Events.UPDATE, this.update, this);
  }
}
